<template>
  <div class="pd-QuickEdit my-2">
    <div class="d-flex">
      <a :href="editPath" v-if="!deleted" class="btn btn-sm btn-gray-700 btn-icon">
        <div class="icon i-lg icon-edit"></div>
        <span class="pl-1 d-none d-lg-inline-block">{{ translations.edit }}</span>
      </a>
      <CacheableForm :form-path="togglePath" class="d-none d-sm-block" method="PUT">
        <button class="btn btn-sm ml-1 btn-gray-700 btn-icon" type="submit">
          <div :class="toggleClass" class="icon i-lg"></div>
          <span class="pl-1 d-none d-lg-inline-block">{{ toggleText }}</span>
        </button>
      </CacheableForm>
      <CacheableForm
        :form-path="deletePath"
        v-if="!deleted"
        class="d-none d-sm-block"
        method="DELETE"
      >
        <button class="btn btn-sm ml-1 btn-gray-700 btn-icon" type="submit">
          <div class="icon i-lg icon-trash"></div>
          <span class="pl-1 d-none d-lg-inline-block">{{ translations.delete }}</span>
        </button>
      </CacheableForm>
    </div>
  </div>
</template>

<script>
import CacheableForm from "./FormsCacheableForm";
import { mapGetters } from "vuex";

export default {
  name: "ProductQuickEditButtons",
  components: {
    CacheableForm,
  },
  props: {
    translations: {
      type: Object,
      required: true,
    },
    editPath: {
      type: String,
      required: true,
    },
    deletePath: {
      type: String,
      required: true,
    },
    togglePath: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      viewable: "productShow/availableOn",
      deleted: "productShow/deletedAt",
    }),
    toggleClass() {
      return this.viewable ? "icon-eye" : "icon-eye-off";
    },
    toggleText() {
      return this.viewable ? this.translations.set_invisible : this.translations.set_visible;
    },
  },
};
</script>
